export class AsignacionEvaluacion {
    puestoid: number = 0;
    departamentoid: number = 0;
    puestoporcolaboradorid: number = 0;
    colaboradorid: number = 0;
    departamento: string = "";
    puesto: string = "";
    colaborador: string = "";
    apellidopaterno: string = "";
    
    constructor(init?: Partial<AsignacionEvaluacion>) {
        Object.assign(this, init);
    }
    
    }